<div class="filter-area" [formGroup]="filterForm">
  <div class="row">

    @if (selectedTabIndex == 0) {
      <div class="col-3 mt-2">
        <div class="btn-group dropdown-wrapper-list filter-input ps-0 pe-0" dropdown style="width: 100%; min-width: auto;border: none;">
                <button type="button" class="btn btn-primary action-dropdown p-0 text-start ps-3 text-dark-grey fs-13"  #toggleButton dropdownToggle data-bs-auto-close="inside" style="background-color: white !important;
                height: 37px;
                color: #707070;
                width: 80%;">
            {{ 'MAIN.CONTENT.WORK-ORDERS.SELECT-STATUS' | translate }}
          </button>
          <button id="button-split" type="button"  class="btn dropdown-toggle dropdown-toggle-split"  (click)="$event.stopPropagation(); toggleButton.click()"
                        aria-controls="dropdown-split" data-bs-auto-close="false" auto-close="false" style="background-color: white;
                        border-color: #eff1f5;
                        border-left-color: white;
                        height: 37px;
                        width: 15px;">
          </button>
                <ul id="dropdown-split" *dropdownMenu class="dropdown-menu" role="menu" onclick="event.stopPropagation()"  style="max-height: 240px; 
                overflow-y: scroll;" [formGroup]="statusGroup" aria-labelledby="dropdownMenuClickableInside">
            @for (status of statusOptions; track status; let index = $index) {
              <div class="ps-2">
                <div class="custom-control custom-checkbox custom-checkbox-green" [ngClass]="{'mt-2':index == 0}">
                  <input
                    type="checkbox"
                    class="form-check-input ms-0"
                    [id]="'status-'+index"
                    (click) = selectStatus(status.value)
                    [formControlName]="status.value"
                    />
                  <label class="custom-control-label label-form fs-14" [for]="'status-'+index">
                    {{ status.name }}
                  </label>
                </div>
              </div>
            }
          </ul>
        </div>
      </div>
    }

    <div class="col-3 mt-2">
      <div class="btn-group dropdown-wrapper-list filter-input ps-0 pe-0" dropdown style="width: 100%; min-width: auto;border: none;">
                <button type="button" class="btn btn-primary action-dropdown p-0 text-start ps-3 text-dark-grey fs-13"  #toggleButton dropdownToggle data-bs-auto-close="inside" style="background-color: white !important;
                height: 37px;
                color: #707070;
                width: 80%;">
          {{ 'MAIN.CONTENT.WORK-ORDERS.SELECT-PRIORITY' | translate }}
        </button>
        <button id="button-split" type="button"  class="btn dropdown-toggle dropdown-toggle-split"  (click)="$event.stopPropagation(); toggleButton.click()"
                        aria-controls="dropdown-split" data-bs-auto-close="false" auto-close="false" style="background-color: white;
                        border-color: #eff1f5;
                        border-left-color: white;
                        height: 37px;
                        width: 15px;">
        </button>
                <ul id="dropdown-split" *dropdownMenu class="dropdown-menu" role="menu" onclick="event.stopPropagation()"  style="max-height: 240px; 
                overflow-y: scroll;" [formGroup]="priorityGroup" aria-labelledby="dropdownMenuClickableInside">

          @for (priority of priorityOptions; track priority; let index = $index) {
            <div class="ps-2">
              <div class="custom-control custom-checkbox custom-checkbox-green" [ngClass]="{'mt-2':index == 0}">
                <input
                  type="checkbox"
                  class="form-check-input ms-0"
                  [id]="'priority-'+index"
                  (click) = selectPriority(priority.value)
                  [formControlName]="priority.value"
                  />
                <label class="custom-control-label label-form fs-14" [for]="'priority-'+index">
                  {{ priority.name }}
                </label>
              </div>
            </div>
          }

        </ul>
      </div>

    </div>

    <div class="col-3 mt-2">
      <div class="btn-group dropdown-wrapper-list filter-input ps-0 pe-0" dropdown style="width: 100%; min-width: auto;border: none;">
                <button type="button" class="btn btn-primary action-dropdown p-0 text-start ps-3 text-dark-grey fs-13"  #toggleButton dropdownToggle data-bs-auto-close="inside" style="background-color: white !important;
                height: 37px;
                color: #707070;
                width: 80%;">
          {{ 'MAIN.CONTENT.WORK-ORDERS.SELECT-ASSIGNEE' | translate }}
        </button>
        <button id="button-split" type="button"  class="btn dropdown-toggle dropdown-toggle-split"  (click)="$event.stopPropagation(); toggleButton.click()"
                        aria-controls="dropdown-split" data-bs-auto-close="false" auto-close="false" style="background-color: white;
                        border-color: #eff1f5;
                        border-left-color: white;
                        height: 37px;
                        width: 15px;">
        </button>
                <ul id="dropdown-split" *dropdownMenu class="dropdown-menu" role="menu" onclick="event.stopPropagation()"  style="max-height: 240px; 
                overflow-y: scroll;" aria-labelledby="dropdownMenuClickableInside">

          @for (assignee of userList; track assignee; let index = $index) {
            <div class="ps-2">
              <div class="custom-control custom-checkbox custom-checkbox-green" [ngClass]="{'mt-2':index == 0}">
                <input
                  type="checkbox"
                  class="form-check-input ms-0"
                  [id]="'assignee-'+index"
                  (click) = selectAssignee(assignee)
                  />
                <label class="custom-control-label label-form fs-14" [for]="'assignee-'+index">
                  {{ assignee.name }}
                </label>
              </div>
            </div>
          }

        </ul>
      </div>

    </div>

    <div class="col-3 mt-2">
      <div class="btn-group dropdown-wrapper-list filter-input ps-0 pe-0" dropdown style="width: 100%; min-width: auto; border: none;">
        <button type="button" class="btn btn-primary action-dropdown p-0 text-start ps-3" (click)="toggle()" #toggleButton dropdownToggle data-bs-auto-close="inside">
          {{ 'MAIN.CONTENT.WORK-ORDERS.SELECT-LABEL' | translate }}
        </button>
        <button id="button-split" type="button"  class="btn dropdown-toggle dropdown-toggle-split"  (click)="$event.stopPropagation(); toggleButton.click()"
          aria-controls="dropdown-split" data-bs-auto-close="false" auto-close="false">
        </button>
                <ul id="dropdown-split" *dropdownMenu class="dropdown-menu" role="menu" onclick="event.stopPropagation()"  style="max-height: 240px; 
                overflow-y: scroll;" [formGroup]="labelGroup" aria-labelledby="dropdownMenuClickableInside">
          <div class="search-box p-2">
            <input  type="text" class="form-control fs-14" [formControl]="labelSearchControl" style="height: 38px;"  placeholder="{{ 'MAIN.CONTENT.WORK-ORDERS.SEARCH' | translate }}" inputSelectOnFocus [inputSelectOnCreate]="true">
            <div class="search-icon me-2"> <img src="assets/img/search-copy.svg" alt=""></div>
          </div>
          @for (label of filteredLabelList; track label; let index = $index) {
            <div class="ps-2">
              <div class="custom-control custom-checkbox custom-checkbox-green">
                <input
                  type="checkbox"
                  class="form-check-input ms-0"
                  [id]="'label-'+index"
                  (click) = selectLabels(label)
                  [formControlName]="label"
                  />
                <label class="custom-control-label label-form fs-14" [for]="'label-'+index">
                  {{ label }}
                </label>
              </div>
            </div>
          }
        </ul>
      </div>
    </div>

    <div class="col-3 mt-2">
      <div class="search-box">
        <input type="text" [formControl]="name" placeholder="{{ 'MAIN.CONTENT.WORK-ORDERS.SEARCH' | translate }}" class="filter-input fs-14 w-100" style="min-width: auto;">
        <div class="search-icon"> <img src="assets/img/search.svg" alt=""></div>
      </div>
    </div>

    <div class="col-3 mt-2">
      <input #startDate="bsDatepicker" [formControl]="dueDate"  name="startDate" class="form-control fs-14" id="form-control" style="width: 100%;min-width: auto; height: 38px;margin-left: 20px;" bsDatepicker
        autocomplete="off" placeholder="{{ 'MAIN.CONTENT.WORK-ORDERS.SELECT-DUE-DATE' | translate }}"
        [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-blue', customTodayClass: 'datepicker-today' }" onkeypress="return false;" >
    </div>
  </div>

</div>